import axios from 'axios';
import CONFIG from '../config';

export const getDealers = (payload) => {
  // If we have lat/lng coordinates, use our API with proximity search
  if (payload.lat && payload.lng) {
    if (CONFIG.DEBUG) {
      console.log('Dealer search payload:', payload);
      console.log('Coordinates:', { lat: payload.lat, lng: payload.lng, type: { lat: typeof payload.lat, lng: typeof payload.lng } });
    }
    
    return axios.get(`${CONFIG.API_BASE}/dealers`, {
      params: {
        lat: payload.lat,
        lng: payload.lng,
        radius: payload.radius || 50, // Default 50km radius
        car_model: payload.car_model?.toLowerCase(),
      },
    }).then(response => {
      if (CONFIG.DEBUG) {
        console.log('API response:', response.data);
        console.log('Dealers with distances:', response.data.data.map(d => ({ name: d.name, distance: d.distance })));
      }
      
      // Transform our API response to match the expected Woosmap format
      return {
        features: response.data.data.map(dealer => ({
          properties: {
            name: dealer.name,
            address: {
              city: dealer.locality,
            },
            distance: dealer.distance || 0,
            user_properties: {
              sap_dealer_code: dealer.dealer_code,
            },
            store_id: dealer.id,
          },
          geometry: {
            coordinates: [dealer.longitude, dealer.latitude],
          },
        })),
      };
    });
  }
};

export const getDealer = async (SAP_DEALER_CODE) => {
  if (!SAP_DEALER_CODE) { return null; }

  try {
    // Try our API first
    const response = await axios.get(`${CONFIG.API_BASE}/dealers/${SAP_DEALER_CODE}`);
    
    if (response.data) {
      const dealer = response.data?.data;
      
      // Transform to match expected format
      const transformedDealer = {
        properties: {
          name: dealer.name,
          address: {
            city: dealer.locality,
          },
          user_properties: {
            sap_dealer_code: dealer.dealer_code,
          },
          store_id: dealer.id,
        },
        geometry: {
          coordinates: [dealer.longitude, dealer.latitude],
        },
      };

      // Add testdrive code if available
      try {
        const codes_response = await axios.get('/dealers/dealer_codes.json').then(response => response.data);
        transformedDealer.properties.user_properties.testdrive_code = codes_response[SAP_DEALER_CODE];
      } catch(e) {
        if (CONFIG.DEBUG) { console.warn('error during dealer code mapping', e); }
      }

      return transformedDealer;
    }
  } catch(e) {
    if (CONFIG.DEBUG) { console.warn('error fetching dealer from API', e); }
  }

  return null;
};
